import React from "react";
import Header from "./components/Hearder";
import Hero from "./components/Hero";
import ImpactSection from "./components/ImpactSection";
import ServicesSection from "./components/ServicesSection";
import ExpertSupportSection from "./components/ExpertSupportSection";
import TrustSection from "./components/TrustSection";
import WhyChooseUsSection from "./components/WhyChooseUsSection";
import BlogSection from "./components/BlogSection";
import TestimonialsSection from "./components/TestimonialsSection";
import Footer from "./components/Footer";

function NewHome() {
  return (
    <div className="font-sans text-gray-800">
      <Header />
      <main>
        <Hero />
        <ImpactSection />
        <ServicesSection />
        <ExpertSupportSection />
        <TrustSection />
        <WhyChooseUsSection />
        <BlogSection />
        <TestimonialsSection />
        {/* < Plans />
        <Clients />
        <Contact /> */}
      </main>
      <Footer />
    </div>
  );
}

export default NewHome;